import { createSelector } from 'reselect';
import { createApiSelector, createInfoSelectorMaker, createPaginationSelectors } from './common';
import { NAME_NOTICE } from '../reducers/noticeReducer'

export const selectNotice = state => state[NAME_NOTICE.ROOT]
export const makeSelectNoticeInfo = createInfoSelectorMaker(createSelector(selectNotice, notice => notice.get(NAME_NOTICE.INFO)))
export const selectNoticeList = createPaginationSelectors(createSelector(selectNotice, notice => notice.get(NAME_NOTICE.LIST)))
export const selectNoticePost = createApiSelector(createSelector(selectNotice, notice => notice.get(NAME_NOTICE.POST)))
